var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "url(#paint0_radial_160_16)",
    fillOpacity: 0.34
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1463 18.9119C14.9653 20.0969 8.41227 21.5203 8.31534 15.6779C8.31534 15.6779 8.51565 13.4142 11.3269 13.2717C11.3269 13.2717 11.4216 11.2611 13.5694 11.0335C14.724 10.91 16.0359 12.0845 16.1781 13.3206C16.1781 13.3206 19.0194 12.8015 19.1422 15.5375C19.1852 16.4907 18.9677 18.1119 16.2276 18.0416C16.2276 18.0416 14.6422 17.8289 14.4267 15.4077C13.9808 20.0947 20.8418 19.8224 20.9409 15.5652C20.984 13.7248 19.7906 11.8313 17.1022 12.1866C15.6287 8.52507 11.706 8.73571 10.2455 12.1313C8.15805 12.1313 6.56185 13.7184 6.58559 15.7907C6.6653 22.4606 16.0639 20.4501 24.1463 18.9119Z",
    fill: "#24339B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_160_16",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15 15) rotate(90) scale(15)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0020FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.561,
    height: 10.9756,
    fill: "white",
    transform: "translate(6.58533 9.51221)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEther);
export default __webpack_public_path__ + "static/media/Ether.1c4ce1a47aea0150c057b350cb261487.svg";
export { ForwardRef as ReactComponent };